import { environment } from "./../../../environments/environment";
import { Injectable } from "@angular/core";
import { Http, Response, Headers } from "@angular/http";
import "rxjs/add/operator/map";
import "rxjs/add/operator/toPromise";
import "rxjs/Rx";
import { Observable } from "rxjs/Observable";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable()
export class PaymentService {
  baseUrl: string = environment.api_base_url;
  // baseUrl: string = 'http://192.168.8.100:8000/api/';

  constructor(public http: HttpClient) {}

  getInstallments(data): any {
    return this.http.post(
      `${this.baseUrl}installments/generate`,
      JSON.stringify(data)
    );
  }

  getOfferPdf(data): any {
    return this.http.post(
      `${this.baseUrl}projectsOfferImages/generate_file`,
      JSON.stringify(data)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/payment/payment.service.ts